﻿import React, {Component} from 'react';
import FeedSourceList from './feed-source-list'
import {IconButton} from 'material-ui';
import AddIcon from 'material-ui/svg-icons/content/add';
import ListAppBar from '../core/list-app-bar';

class FeedSources extends Component {
    render() {
        return (
            <div>
                <ListAppBar title="Feed Sources"
                            iconElementRight={
                                <IconButton href={'/feed-source/0'}><AddIcon/></IconButton>
                            }
                />
                <FeedSourceList/>
            </div>

        )
    }
}

FeedSources.contextTypes = {
    router: React.PropTypes.any.isRequired
};

export default FeedSources;